
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../../components/feature/LanguageSelector';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  // ---------- Scroll handling ----------
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    // Attach listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ---------- Smooth scroll to a section ----------
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`
        fixed top-0 left-0 right-0 z-50 transition-all duration-300
        ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}
      `}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Desktop navigation links */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('quem-somos')}
              className={`
                text-sm font-medium transition-colors cursor-pointer whitespace-nowrap
                ${scrolled ? 'text-black hover:text-gray-600' : 'text-white hover:text-white/80'}
              `}
            >
              {t('nav.quemSomos')}
            </button>

            <button
              onClick={() => scrollToSection('servicos')}
              className={`
                text-sm font-medium transition-colors cursor-pointer whitespace-nowrap
                ${scrolled ? 'text-black hover:text-gray-600' : 'text-white hover:text-white/80'}
              `}
            >
              {t('nav.servicos')}
            </button>

            <button
              onClick={() => scrollToSection('portfolio')}
              className={`
                text-sm font-medium transition-colors cursor-pointer whitespace-nowrap
                ${scrolled ? 'text-black hover:text-gray-600' : 'text-white hover:text-white/80'}
              `}
            >
              {t('nav.portfolio')}
            </button>

            <button
              onClick={() => scrollToSection('processo')}
              className={`
                text-sm font-medium transition-colors cursor-pointer whitespace-nowrap
                ${scrolled ? 'text-black hover:text-gray-600' : 'text-white hover:text-white/80'}
              `}
            >
              {t('nav.processo')}
            </button>
          </div>

          {/* Language selector + CTA button */}
          <div className="flex items-center gap-4 ml-auto">
            <LanguageSelector scrolled={scrolled} />
            <button
              onClick={() => scrollToSection('formulario')}
              className="bg-black text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('nav.pedirOrcamento')}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
